const id_whs_itemmove = {
    "": "perpindahan barang",
    detail: "detail perpindahan barang",
}

export default id_whs_itemmove;